<template>
  <div class="CalendarLayout">

    <div class="CalendarLayout_left">
      <el-select v-model="campus" :placeholder="$t('original.languages3')" style="position: absolute;top: 10px;left: 20px;height: 30px;" @change="Campus_switching()">
        <el-option :label="$t('original.languages114')" value="">
        </el-option>
        <el-option v-for="item in campus_list" :key="item.cDicEnglishValue" :label="item.cDicValue" :value="item.dicKey">
        </el-option>
      </el-select>

      <el-button v-if="pdroleid(1057) || pdroleid(1066)" type="primary" style="position: absolute;top: 13px;left: 220px;height: 30px;" @click="gotoAddSchList">{{$t('original.languages446')}}</el-button>

      <el-calendar v-model="currentDate">
        <template slot="dateCell" slot-scope="{date, data}">


        <div class="Interview_typesetting_nav" style="width: 100%;height: 100%;" @click="romm_details(data.day, data.TencentLink)">
 
          <p class="p0" :class="data.isSelected ? 'is-selected' : ''">
            {{ data.day.split('-').slice(2).join('-') }}
          </p>

          <div v-for="(item,i) in datas" :key="i" class="yudiv">
            <div v-if="item.Day == data.day.split('-').slice(0).join('-')">
              <div :style="item.SpecialFlag == 1 ? 'background-color:#ffd5d5;':''" class="hxsiojxosp"></div>
              <div v-for="ite in item.Details" :key="ite.id" style="position: relative;z-index:2;">
                <p class="p1" v-if="ite.TimeZoneName == '上午'">
                  <span>{{$t('original.languages286')}}</span>
                  <i>{{$t('original.languages447')}}：{{ ite.ScheduledCount }}</i>
                  <em>{{$t('original.languages448')}}：{{ ite.UnscheduledCount }}</em>
                </p>
                <p class="p2" v-if="ite.TimeZoneName == '下午'">
                  <span>{{$t('original.languages287')}}</span>
                  <i>{{$t('original.languages447')}}：{{ ite.ScheduledCount }}</i>
                  <em>{{$t('original.languages448')}}：{{ ite.UnscheduledCount }}</em>
                </p>
                <p class="p3" v-if="ite.TimeZoneName == '晚上'">
                  <span>{{$t('original.languages285')}}</span>
                  <i>{{$t('original.languages447')}}：{{ ite.ScheduledCount }}</i>
                  <em>{{$t('original.languages448')}}：{{ ite.UnscheduledCount }}</em>
                </p>
              </div>
            </div>
          </div>


        </div>
      </template>
      </el-calendar>
    </div>

    <div class="CalendarLayout_right">
      <h2>{{$t('original.languages449')}}</h2>
      <el-collapse class="CalendarLayout_right_collapse" v-model="activeNames" @change="handleChange">
        <el-collapse-item v-for="(item,i) in data" :key="i" :title="item.Campus + '(' + item.Count + ')'" :name="i+1">
          <ul class="CalendarLayout_right_ul1">
            <li v-for="(ite, i) in item.List" :key="i">
              <div class="CalendarLayout_right_ul1_div">
                <img :src="ite.ZHeadPhotoURL" alt="">
                <h6>{{ ite.UserName }}</h6>
                <p class="pd">{{ $t('original.languages450') }}: <i style="color: rgba(21, 191, 109, 1);">{{ ite.Rest }}</i> | {{ ite.Total }}</p>
                <span class="ihs" style="color: rgba(0, 136, 255, 1);cursor:pointer" @click="View(ite)">{{$t('original.languages174')}}</span>
                <p class="campus">{{ ite.Campus }}</p>
              </div>
              <ul class="CalendarLayout_right_ul2" v-for="(it, i) in ite.ScheduleList" :key="i">
                <li style="position: relative;">
                  <!-- <i>{{ it.ConsultType }}</i> -->
                  <span style="margin-left: 10px;">{{ it.StartTime.slice(0, 5) }} - {{ it.FinishTime.slice(0, 5) }}</span>
                  <span style="color: rgba(58, 194, 130, 1);margin-left: 20px;" v-if="it.Status == '可约'">{{ it.Status }}</span>
                  <span style="color: rgba(158, 158, 158, 1);margin-left: 20px;" v-else>{{ it.Status }}</span>
                  <span v-if="it.SchedulType == '普通排班'" style="display: inline-block; color: rgb(155 155 155);margin-left: 10px;width: 40px;position: relative;">
                    <img style="position: absolute;top: -13px;" src="../../assets/20230725195707_1.png" alt="" v-bind:title="tooltipText1" v-on:mouseover="showTooltip1" v-on:mouseleave="hideTooltip1">                    
                  </span>
                  <span v-else style="display: inline-block; color: rgb(255, 0, 0);margin-left: 10px;width: 10px;height: 10px;position: relative;">
                    <img style="position: absolute;top: -3px;" src="../../assets/20230725195707.png" alt="" v-bind:title="tooltipText2" v-on:mouseover="showTooltip2" v-on:mouseleave="hideTooltip2">                    
                  </span>
                  <span v-if="it.ConsultType == '视频咨询,面对面咨询' || it.ConsultType == '视频咨询' || it.ConsultType == '面对面咨询,视频咨询'" style="display: inline-block; color: rgb(255, 0, 0);margin-left: 10px;width: 10px;height: 10px;position: relative;">
                    <img style="position: absolute;top: -3px;" src="../../assets/20230725194847.png" alt="" v-bind:title="tooltipText3" v-on:mouseover="showTooltip3" v-on:mouseleave="hideTooltip3">                
                  </span>
                  <span v-if="it.ConsultType == '视频咨询,面对面咨询' || it.ConsultType == '面对面咨询' || it.ConsultType == '面对面咨询,视频咨询'" style="display: inline-block; color: rgb(255, 0, 0);margin-left: 10px;width: 10px;height: 10px;position: relative;">
                    <img style="position: absolute;top: -3px;" src="../../assets/20230725194847_1.png" alt="" v-bind:title="tooltipText4" v-on:mouseover="showTooltip4" v-on:mouseleave="hideTooltip4">    
                  </span>
                  <span v-if="pdroleid(1057) || pdroleid(1066)" style="color: rgba(0, 136, 255, 1);margin-left: 70px;cursor:pointer;position: absolute;right: 55px;" @click="edits(it)">{{ $t('original.languages57') }}</span>
                  <span v-if="it.Status == '可约' && pdroleid(1057) || pdroleid(1066)" style="color: rgba(0, 136, 255, 1);margin-left: 10px;cursor:pointer;position: absolute;right: 10px;" @click="deletes(it)">{{ $t('original.delete') }}</span>
                </li>
              </ul>
            </li>

          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-drawer class="drawer" title="我是标题" :visible.sync="drawer" :with-header="false">
      <h6>{{ $t('original.languages451') }}</h6>

      <div class="drawer_div">
        <img :src="Personal_data.ZHeadPhotoURL" alt="">
        <h6>{{ Personal_data.UserName }}</h6>
        <p>{{ Personal_data.IndividualResume }}</p>
      </div>

      <span>{{$t('original.languages452')}}：</span>
      <p>{{ Personal_data.Campus }}</p>
      <span>{{$t('original.languages453')}}：</span>
      <p>{{ Personal_data.Expertise }}</p>
      <span>{{$t('original.languages454')}}：</span>

      <ul>
        <li v-for="(item,i) in Personal_data.Certs" :key="i">
          <img :src="item" alt="">
        </li>
      </ul>

      <span>{{$t('original.languages455')}}：</span>
      <p>{{ Personal_data.createdDate }}</p>
    </el-drawer>

    <el-dialog :title="$t('original.delete')" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <p style="margin-top: 10px;color: rgba(92, 92, 92, 1);">{{$t('original.languages225')}}: <span style="color: rgba(40, 40, 40, 1);">{{ deledata.UserName }}</span></p>
      <p style="margin-top: 20px;color: rgba(92, 92, 92, 1);">{{$t('original.languages272')}}: <span style="color: rgba(40, 40, 40, 1);">{{ deledata.SchedulDate }}</span></p>
      <p style="margin-top: 20px;color: rgba(92, 92, 92, 1);float: left;">{{$t('original.languages456')}}：<el-input :placeholder="$t('original.languages457')" v-model="input" clearable></el-input></p>
      <el-button type="primary" @click="deletefun()" style="margin-left: -117px;margin-top: 100px;">{{$t('original.languages458')}}</el-button>
    </el-dialog>

    <el-dialog class="xax" :title="$t('original.languages57')" :visible.sync="xgdialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px">

        <el-form-item :label="$t('original.languages225')">
          {{ form.UserName }}
        </el-form-item>

        <el-form-item :label="$t('original.languages71')">
          <el-time-select :placeholder="$t('original.languages71')" :clearable="aaa" v-model="form.StartTime" :picker-options="{ start: '06:30', step: '00:05', end: '23:00' }">
          </el-time-select>
        </el-form-item>

        <el-form-item :label="$t('original.languages186')">
          <el-time-select :placeholder="$t('original.languages186')" :clearable="aaa" v-model="form.FinishTime" :picker-options="{ start: '06:30', step: '00:05' ,end: '23:00' }">
          </el-time-select>
        </el-form-item>

        <el-form-item :label="$t('original.languages212')">
          <el-select v-model="form.ConsultType" placeholder="请选择活动区域">
            <el-option label="视频咨询" value="视频咨询"></el-option>
            <el-option label="面对面咨询" value="面对面咨询"></el-option>
            <el-option label="面对面咨询 + 视频咨询" value="面对面咨询,视频咨询"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="this.SchedulType == '特殊排班'" :label="$t('original.languages459')">
          <span>{{ DeptName }}</span>
        </el-form-item>

        <el-form-item :label="$t('original.languages226')">
          <!-- {{ form.Campus }} -->
          <el-select v-model="xgcampus" :placeholder="$t('original.languages3')">
            <el-option v-for="item in GetConAddress_list" :key="item.cDicEnglishValue" :label="item.ConAddressName" :value="item.ConAddressID">
            </el-option>
          </el-select>
        </el-form-item>
<!-- 
        <el-form-item label="修改原因">
          <el-input type="textarea" v-model="form.Reason"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="onSubmit()">{{$t('original.languages57')}}</el-button>
          <el-button @click="xgdialogVisible = false">{{$t('original.cancel')}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SchedulType: '',
      DeptName:'',
      GetConAddress_list:[],
      xgcampus: '',
      luanjai:'',
      form: {
        Campus: '',
        UserName: '',
        StartTime: '',
        FinishTime: '',
        Reason: '',
        ConsultType: '',
        SchedulKey: '',
        SchedulDate: '',
      },
      aaa:false,
      input:'',//删除原因：
      dialogVisible: false,//删除
      xgdialogVisible: false,//修改
      currentDate: new Date(),
      activeNames: ['1'],
      drawer: false,//查看资料控制
      campus_list:[],//校区列表
      campus: '',//校区
      RoleID: '',//角色id
      datas: [],//排版列表数据
      Personal_data: [],//个人资料
      deledata:[],//删除显示数据
      time: new Date().toLocaleDateString().replaceAll("/", "-"),
      AdminFlag:true,
      showingTooltip1: false,
      tooltipText1: "普通排班",
      showingTooltip2: false,
      tooltipText2: "特殊排班",
      showingTooltip3: false,
      tooltipText3: "视频咨询",
      showingTooltip4: false,
      tooltipText4: "面对面咨询",
      data: []
    }
  },
  props: {

  },
  watch: {
    currentDate: {//上下月点击事件监听
      handler(newVal, objVal) {
        if (newVal) {
          this.time = this.format(newVal.getTime());
          this.load();
        }
      },
    },
  },
  methods: {
    pdroleid(id) {

      var RoleID = sessionStorage.getItem('RoleID')
      if (RoleID.indexOf(id) !== -1) {
        return true
      } else {
        return false
      }
    },
    add0(m) { return m < 10 ? '0' + m : m },
    format(shijianchuo) {//shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + '-' + m + '-' + this.add0(m);
    },
    showTooltip1() {
      this.showingTooltip1 = true;
    },
    hideTooltip1() {
      this.showingTooltip1 = false;
    },
    showTooltip2() {
      this.showingTooltip2 = true;
    },
    hideTooltip2() {
      this.showingTooltip2 = false;
    },
    showTooltip3() {
      this.showingTooltip3 = true;
    },
    hideTooltip3() {
      this.showingTooltip3 = false;
    },
    showTooltip4() {
      this.showingTooltip4 = true;
    },
    hideTooltip4() {
      this.showingTooltip4 = false;
    },
    onSubmit() {//立即修改
      if (Number(this.form.FinishTime.slice(0, 2)) * 60 + Number(this.form.FinishTime.slice(3, 5)) > Number(this.form.StartTime.slice(0, 2)) * 60 + Number(this.form.StartTime.slice(3, 5)) + 60) {
        alert(this.$t('original.languages460'));
      } else {
        var ConsultType;
        if (this.form.ConsultType == '面对面咨询,视频咨询') {
          ConsultType = '0,1'
        } else if (this.form.ConsultType == '视频咨询') {
          ConsultType = '1'
        } else if (this.form.ConsultType == '面对面咨询') {
          ConsultType = '0'
        }

        this.$Http_Post("ConsultSubscribe/UpdateVeryPaiBan", { 'SchedulKey': this.form.SchedulKey, 'StartTime': this.form.StartTime, 'FinishTime': this.form.FinishTime ,'Reason': this.form.Reason ,'ConsultType': ConsultType , ConAddressKey : this.xgcampus }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.$message.success(res.Message);
            this.xgdialogVisible = false;
            this.ShowVeryPaiBan(this.form.SchedulDate);
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },


    edits(SchedulKey) {
      this.DeptName = SchedulKey.DeptName;
      this.SchedulType = SchedulKey.SchedulType;
      // this.xgcampus = Number(SchedulKey.ConAddressKey) 
      this.xgcampus = SchedulKey.ConAddressKey.toString();
      this.xgdialogVisible = true;
      this.form = {
        Campus: SchedulKey.Campus,
        UserName: SchedulKey.UserName,
        StartTime: SchedulKey.StartTime.slice(0, 5),
        FinishTime: SchedulKey.FinishTime.slice(0, 5),
        Reason: SchedulKey.Reason,
        ConsultType: SchedulKey.ConsultType,
        SchedulKey: SchedulKey.SchedulKey,
        SchedulDate: SchedulKey.SchedulDate,
      }
    },

    deletefun() {//确定删除
      this.$Http_Post("ConsultSubscribe/DeleVeryPaiBan", { 'SchedulKey': this.deledata.SchedulKey, 'Reason': this.input }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message);
          this.dialogVisible = false;
          this.ShowVeryPaiBan(this.deledata.SchedulDate);
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    deletes(SchedulKey) {//删除
      this.deledata = SchedulKey;
      this.dialogVisible = true;
    },
    View(data) {//查看
      this.drawer = true;
      this.Personal_data = data;
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
      .then(_ => {
        done();
      })
      .catch(_ => { });
    },
    Campus_switching() {//校区切换
      this.load();
    },
    romm_details(day, TencentLink) {//展示指定日期排班情况
      this.ShowVeryPaiBan(day);
      this.luanjai = day.slice(8, 10)
    },
    gotoAddSchList() {
      this.$router.push('/Consultant/Consultingadd');
    },
    ShowVeryPaiBan(day) {//展示指定日期排班情况函数
      this.$Http_Post("ConsultSubscribe/ShowVeryPaiBan", { 'Day': day , Campus : this.campus }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    handleChange(val) {},
    load() {
      this.$Http_Post("ConsultSubscribe/ShowCounselorAllPaiBan", {'AdminFlag': this.AdminFlag, 'Campus':this.campus ,'ConsultType':'','Counselor':'','ExportFlag':false, Time :this.time}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.datas = res.Data;
        } else {
          this.$message.error(res.Message);
        }
      });
    }
  },
  mounted() {
    this.RoleID = JSON.parse(sessionStorage.getItem('xinxi')).RoleID;
    if (this.Global.pdroleid(1057)) {
      this.AdminFlag = true;
    } else {
      this.AdminFlag = false;
    }
    this.$Http_Post("User/GetDictionaryList", {'DicTypCode':16}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
        // this.campus = res.Data[0].dicKey;
        this.load();
      } else {
        this.$message.error(res.Message);
      }
    });
    this.$Http_Post("ConsultSubscribe/GetConAddress", { 'pageIndex': 1, pageSize:999999999999 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetConAddress_list = res.Data;
      } else {
        this.$message.error(res.Message);
      }
    });
  },
}
</script>
<style>
  .CalendarLayout{width: 100%;height: 100%;}
  .CalendarLayout .el-dialog__body{height: 240px;}
  .CalendarLayout .xax .el-dialog__body{height: 540px;}
  .CalendarLayout .el-input{width: 75%;}
  .CalendarLayout .el-calendar-table thead th{color: #fff;}
  .CalendarLayout .el-calendar-table .el-calendar-day{height: 150px;position: relative;}
  .CalendarLayout .el-calendar__title{margin-left:45%;font-size: 20px;}
  .CalendarLayout .CalendarLayout_left{width: calc(100% - 370px);float: left;background-color: #fff;height: 100%;position: relative;overflow: auto;}
  /* .CalendarLayout .CalendarLayout_left::-webkit-scrollbar {width: 0px;}
  .CalendarLayout .CalendarLayout_left::-webkit-scrollbar-thumb {display: none;} */
  .CalendarLayout .CalendarLayout_right{width: 360px;float: right;height: 100%;background-color: #fff;border-radius: 10px;overflow: auto;}
  .CalendarLayout .CalendarLayout_right::-webkit-scrollbar {width: 0px;}
  .CalendarLayout .CalendarLayout_right::-webkit-scrollbar-thumb {display: none;}
  .CalendarLayout .CalendarLayout_right h2{margin-left: 15px;padding-top: 15px;width: 330px;border-bottom: 1px solid rgba(214, 214, 214, 1);padding-bottom: 10px;font-size: 18px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li{width: 100%;background-color: rgba(221, 221, 221, 1);margin-top: 10px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li .CalendarLayout_right_ul1_div{height: 70px;position: relative;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li h6{font-size: 14px;position: absolute;top: 10px;left: 80px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_collapse{width: 330px;margin-left: 15px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li .CalendarLayout_right_ul1_div img{width: 50px;height: 50px;border-radius: 50%;position: absolute;top: 10px;left: 10px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li .pd{position: absolute;left: 80px;top: 38px;font-size: 12px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li .ihs{position: absolute;top: 10px;font-size: 12px;right: 20px;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul1>li .campus{color: rgba(132, 132, 132, 1);position: absolute;top: 38px;font-size: 12px;right: 20px !important;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul2 {background-color: #fff;}
  .CalendarLayout .CalendarLayout_right .CalendarLayout_right_ul2 li{height: 40px;line-height: 40px;border-bottom: 1px solid rgba(237, 237, 237, 1);}
  .CalendarLayout .drawer h6{font-size: 18px;padding-top: 20px;margin-left: 5%;}
  .CalendarLayout .drawer .drawer_div{width: 90%;margin-left: 5%;height: 140px;border-bottom: 1px solid #e3e3e3;padding-top: 20px;position: relative;}
  .CalendarLayout .drawer .drawer_div img{width: 100px;height: 100px;border-radius: 5px;position: absolute;top: 30px;}
  .CalendarLayout .drawer .drawer_div h6{position: absolute;top: 10px;left: 100px;}
  .CalendarLayout .drawer .drawer_div p{width: calc(100% - 130px);height: 70px;position: absolute;top: 60px;left: 124px;overflow: auto;}
  .CalendarLayout .drawer .drawer_div p::-webkit-scrollbar {width: 0px;}
  .CalendarLayout .drawer .drawer_div p::-webkit-scrollbar-thumb {display: none;}
  .CalendarLayout .drawer .el-drawer__body>span{color: rgba(92, 92, 92, 1);margin-left: 5%;padding-top: 10px;display: block;}
  .CalendarLayout .drawer .el-drawer__body>p{color: #000;margin-left: 5%;padding-top: 10px;display: block;}
  .CalendarLayout .drawer .el-drawer__body>ul{width: 90%;margin-left: 5%;height: 130px;padding-top: 20px;}
  .CalendarLayout .drawer .el-drawer__body>ul li{float: left;width: 130px;height: 90px;margin-left: 10px;}
  .CalendarLayout .drawer .el-drawer__body>ul li img{width: 100%;height: 100%;}
  .CalendarLayout .p1{background-color: rgba(230, 247, 237, 1);height: 34px;width: 80%;float: right;margin-top: 5px;position: relative;}
  .CalendarLayout .p1 span{display: block;color: rgba(43, 186, 100, 1);position: absolute;top: 8px;left: 10px;}
  .CalendarLayout .p1>i{font-size: 10px;position: absolute;top: 2px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p1>em{font-size: 10px;position: absolute;top: 18px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p2{background-color: rgba(255, 239, 224, 1);height: 34px;width: 80%;float: right;margin-top: 5px;position: relative;}
  .CalendarLayout .p2 span{display: block;color: rgba(255, 141, 26, 1);position: absolute;top: 8px;left: 10px;}
  .CalendarLayout .p2>i{font-size: 10px;position: absolute;top: 2px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p2>em{font-size: 10px;position: absolute;top: 18px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p3{background-color: rgba(225, 239, 252, 1);height: 34px;width: 80%;float: right;margin-top: 5px;position: relative;}
  .CalendarLayout .p3 span{display: block;color: rgba(31, 144, 242, 1);position: absolute;top: 8px;left: 10px;}
  .CalendarLayout .p3>i{font-size: 10px;position: absolute;top: 2px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p3>em{font-size: 10px;position: absolute;top: 18px;left: 50px;font-style: normal;color: #000;}
  .CalendarLayout .p0{position: absolute;z-index: 3;}
  .CalendarLayout .el-calendar__body {min-width: 1200px;}
  .CalendarLayout .el-calendar__header {min-width: 1200px;}
  .hxsiojxosp{position:absolute;top:0;left:0;width:100%;height:100%;}
  .el-calendar-table td.is-selected .hxsiojxosp{background: #edf6ff  !important;}

</style>
